import { ForgotPasswordFormValues } from './types'
import { authorizedEdgeFetch, unauthorizedEdgeFetch } from 'app/axios/edge'

export const LOGIN_ERRORS = {
  WRONG_CREDENTIALS: 110,
  DOMAIN_ERROR: 179,
}

export const passwordReset = (params: ForgotPasswordFormValues) =>
  unauthorizedEdgeFetch.post('/users/password/reset', params)

// Get info about current user which has freshly signed profilePicUrl.
// But doesn't include some info comparing with info from /check (e.g. token and secretKey)
export const getUserSelf = () => authorizedEdgeFetch.get('/users/self')
